"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineEstimatedCheck = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineEstimatedCheck = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            const config = latest_version.config;
            return config?.product?.custom && config?.green_fee?.estimated;
        }
        case "HOTEL": {
            const config = latest_version.config;
            return config?.rooms?.estimated;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            return config?.vehicle?.rate?.estimated;
        }
        case "EXCURSION": {
            const config = latest_version.config;
            return config?.product?.rate?.estimated;
        }
        case "CUSTOM": {
            const config = latest_version.config;
            return config?.pricing?.estimated;
        }
    }
    return null;
};
exports.getOrderLineEstimatedCheck = getOrderLineEstimatedCheck;
